import React from 'react';

import Icon, { Props } from './icon';

export const HidePasswordIcon: React.FC<Props> = (props: Props) => {
  return (
    <Icon viewBox="0 0 36 36" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5942 15.4051C19.1589 13.9737 16.8367 13.975 15.4063 15.4046C13.9742 16.8397 13.9756 19.1618 15.406 20.5918C15.4061 20.592 15.4062 20.5921 15.4064 20.5923C16.8389 22.0258 19.1589 22.0265 20.5939 20.592C22.0257 19.1569 22.0244 16.8351 20.5942 15.4051ZM13.7565 22.2409C16.1007 24.5865 19.8982 24.5857 22.2435 22.2409L22.2443 22.2401C24.5848 19.8956 24.5859 16.0978 22.2435 13.7559L22.2427 13.7551C19.8976 11.4152 16.0989 11.414 13.7565 13.7559L13.7557 13.7567C11.4154 16.1011 11.4141 19.8986 13.7561 22.2405M13.7561 22.2406C13.7563 22.2407 13.7564 22.2408 13.7565 22.2409Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7733 24.6954C30.1958 22.8497 31.5 20.4617 31.5 17.9998C31.5 15.5379 30.1958 13.1499 27.7733 11.3043C25.349 9.45718 21.9011 8.24982 18 8.24982C14.0989 8.24982 10.651 9.45718 8.22667 11.3043C5.80421 13.1499 4.5 15.5379 4.5 17.9998C4.5 20.4617 5.80421 22.8497 8.22667 24.6954C10.651 26.5425 14.0989 27.7498 18 27.7498C21.9011 27.7498 25.349 26.5425 27.7733 24.6954ZM18 29.9998C26.6985 29.9998 33.75 24.6272 33.75 17.9998C33.75 11.3724 26.6985 5.99982 18 5.99982C9.30152 5.99982 2.25 11.3724 2.25 17.9998C2.25 24.6272 9.30152 29.9998 18 29.9998Z"
      />
    </Icon>
  );
};

export default React.memo(HidePasswordIcon);
